module.exports = __webpack_public_path__ + "static/ItemList-71abeb4d5a3ed0c7784dddb336bf9424.png";